<template>
  <div class="EmptyStateOfferCard" @click="$emit('action-forward-click')">
    <OfferCard>
      <OfferCardBrand
        :icon-size="iconSize"
        :icon-name="iconName"
        :artwork="true"
        @click="$emit('brand-click')"
      />
      <OfferCardHorizontalContent>
        <OfferCardLeading>
          <OfferCardLeadingTitle>{{ cptdOfferAmount }}</OfferCardLeadingTitle>
          <OfferCardLeadingCaption>
            {{ customLeadingCaption || cptdInstallmentsLabel }}
          </OfferCardLeadingCaption>
        </OfferCardLeading>
        <OfferCardAction type="ghost" @click="$emit('offer-conditions-click')">
          Simular
        </OfferCardAction>
      </OfferCardHorizontalContent>
      <OfferCardBadge>{{ cptdInterestRate }}%</OfferCardBadge>
      <OfferCardActionForward @click="$emit('action-forward-click')" />
    </OfferCard>
  </div>
</template>

<script>
import OfferCard from '~/aasgard/components/cards/offer-card/OfferCard.vue'
import OfferCardBrand from '~/aasgard/components/cards/offer-card/OfferCardBrand.vue'
import OfferCardHorizontalContent from '~/aasgard/components/cards/offer-card/OfferCardHorizontalContent.vue'
import OfferCardLeading from '~/aasgard/components/cards/offer-card/OfferCardLeading.vue'
import OfferCardLeadingTitle from '~/aasgard/components/cards/offer-card/OfferCardLeadingTitle.vue'
import OfferCardLeadingCaption from '~/aasgard/components/cards/offer-card/OfferCardLeadingCaption.vue'
import OfferCardAction from '~/aasgard/components/cards/offer-card/OfferCardAction.vue'
import OfferCardBadge from '~/aasgard/components/cards/offer-card/OfferCardBadge.vue'
import OfferCardActionForward from '~/aasgard/components/cards/offer-card/OfferCardActionForward.vue'
import { parseToBRL } from '~/helpers/currency'

export default {
  name: 'EmptyStateOfferCard',
  components: {
    OfferCardActionForward,
    OfferCardBadge,
    OfferCardAction,
    OfferCardLeadingTitle,
    OfferCardLeading,
    OfferCardHorizontalContent,
    OfferCardBrand,
    OfferCard,
    OfferCardLeadingCaption,
  },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md'].includes(value) || value === 'md'
      },
    },
    customTitleLabel: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      required: true,
    },
    customLeadingCaptionLabel: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      required: true,
    },
    installmentValue: {
      type: Number,
      required: true,
    },
    customLeadingCaption: {
      type: String,
      default: '',
    },
    interestRate: {
      type: Number,
      required: true,
    },
  },
  emits: ['action-forward-click', 'brand-click', 'offer-conditions-click'],
  computed: {
    cptdOfferAmount() {
      if (this.customTitleLabel) {
        return this.customTitleLabel
      }
      return parseToBRL(this.amount)
    },
    cptdInstallmentsLabel() {
      if (this.customLeadingCaptionLabel) {
        return this.customLeadingCaptionLabel
      }
      return `${this.duration}x de ${parseToBRL(this.installmentValue)}`
    },
    cptdInterestRate() {
      return (this.interestRate ?? 0).toFixed(2)
    },
  },
}
</script>

<style lang="scss"></style>
